import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { RockPaperScissors } from 'modules/Room/features/rock-paper-scissors/rock-paper-scissors';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { MovesEnum } from 'shared/constants/shared-enums';
import { useAccount } from 'shared/hooks/use-web3';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';
import { useRoomStore } from 'shared/store/roomStore';

import pick from 'assets/png/pick-a-hand.png?format=webp;avif&as=picture';

import { buildPlayMoveKey } from './play-menu.utils';

interface MobilePlayMenuProps {
  selectMove: (move: MovesEnum) => void;
}

export const PlayMenu = ({ selectMove }: MobilePlayMenuProps) => {
  const { activeRoomId } = useParams();
  const { address, chainId } = useAccount();
  const { playMoves } = usePlayerGamesStore();
  const { roundCounter } = useRoomStore();

  const selectedMove = useMemo(() => {
    if (!activeRoomId || !address || !chainId) return undefined;

    const key = buildPlayMoveKey(activeRoomId, address, chainId, roundCounter);
    return playMoves?.[key]?.move;
  }, [activeRoomId, address, chainId, playMoves, roundCounter]);

  return (
    <div
      className={
        'absolute bottom-0 left-0 z-50 flex h-[8.5rem] w-full flex-col items-end justify-center pb-6 sm:h-auto md:static lg:rounded-b-[24px]'
      }
      style={{
        background: selectedMove
          ? 'linear-gradient(180deg, rgba(0, 11, 255, 0.00) 0%, rgba(0, 11, 255, 0.25) 100%)'
          : 'linear-gradient(180deg, rgba(0, 11, 255, 0) 0%, #000BFF 100%)',
      }}
    >
      {selectedMove ? (
        <div className="h-[44px]" />
      ) : (
        <OptimizedImage
          imageData={pick}
          alt="pick"
          className="top-[-60px] mx-auto mb-2.5 h-[2.875rem] w-[17.625rem] md:w-[80%] lg:top-[-100px] lg:h-auto"
        />
      )}
      <RockPaperScissors move={selectedMove} selectMove={selectMove} />
    </div>
  );
};
